import React, { useState } from "react";
import { Modal, Row, Col, Typography, Button } from "antd";
import { ExclamationCircleTwoTone } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const TimeoutExtension = (props) => {
  return (
    <>
      <Row>
        <Col span={4}>
          <ExclamationCircleTwoTone style={{ fontSize: "48px" }} twoToneColor='#ff1010' />
        </Col>
        <Col>
          <Title>Error</Title>
        </Col>
      </Row>
      <Paragraph>The detection application was not able to complete the detection and no data was retrieved.</Paragraph>
      <Paragraph>You can retry the application download or continue on with incomplete data.</Paragraph>
      <Row justify='end' gutter={[16, 16]}>
        <Col>
          <Button type='default' onClick={props.onContinue}>
            Continue
          </Button>
        </Col>
        <Col>
          <Button type='primary' onClick={props.onRetry}>
            Retry
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default TimeoutExtension;
